import ShopEvaluation from 'views/web/shop/ShopEvaluation';
import { NextPageWithLayout } from 'pages/_app';
import { getShopInfoData } from 'api/shop';
import { GetServerSideProps } from 'next';

type ShopIndexPageProps = {
  shopData;
};

const ShopEvaluationPage: NextPageWithLayout = (props: ShopIndexPageProps) => {
  return <ShopEvaluation {...props} />;
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const props = {
    shopData: {},
  };
  const serverHeaders = ctx.req.headers;
  const { shopSysNo } = ctx.query;
  const shopData = await getShopInfoData(shopSysNo, {
    serverSide: true,
    headers: serverHeaders,
  });

  if (shopData?.code === 200) {
    const originShopData = shopData.data;
    props.shopData = originShopData;
  }

  return {
    props,
  };
};

ShopEvaluationPage.layoutProps = {
  title: '店铺评价',
};

export default ShopEvaluationPage;
